import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function GuidePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <Navbar />

      {/* Guide Hero */}
      <section className="relative w-full pt-28 pb-16 md:pt-32 md:pb-20 bg-background-50">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <nav className="mb-6">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 text-sm font-label text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line text-sm"></i>
              </div>
              Вернуться на главную
            </Link>
          </nav>

          <h1 className="text-3xl md:text-5xl font-heading font-semibold text-foreground-950 leading-[1.2] mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}>
            Гид по покупкам Yoybuy Sheet
          </h1>
          <p className="text-base md:text-lg text-foreground-600 font-light leading-relaxed max-w-[600px]">
            Полное руководство по заказу товаров из Китая через Yoybuy Spreadsheet.
            Всё, что нужно знать о системе: от регистрации до получения посылки.
          </p>
        </div>
      </section>

      {/* SEO Article 1 */}
      <section className="w-full py-16 md:py-20 bg-white">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <span className="text-[11px] tracking-[0.2em] uppercase text-primary-500 font-label font-medium">
                Статья 1
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-3 mb-4 leading-snug"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Как заказать товары через Yoybuy Spreadsheet
              </h2>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-4">
                <strong>Yoybuy Spreadsheet</strong> позволяет заказывать товары из Китая максимально просто.
                Вам не нужно заполнять сложные веб-формы — достаточно внести ссылки на товары в таблицу,
                указать размеры и количество, и система автоматически обработает ваш заказ. Это экономит
                часы времени и исключает ошибки ручного ввода данных.
              </p>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-5">
                Процесс заказа через <strong>Yoybuy Sheet</strong> интуитивно понятен: регистрация,
                поиск товаров, заполнение таблицы, подтверждение и оплата. Вся коммуникация с агентом
                происходит автоматически — вы просто отслеживаете статус заказа в личном кабинете.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white font-label text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  Перейти в Yoybuy
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </div>
                </a>
                <Link
                  to="/article/yoybuy-spreadsheet-guide"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
                >
                  Читать подробнее
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20spreadsheet%20interface%20on%20warm%20cream%20desk%20with%20fashion%20catalog%20nearby%20soft%20natural%20window%20lighting%20editorial%20product%20photography%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=450&seq=yoybuy-guide-v2-01&orientation=landscape"
                alt="Как заказать через Yoybuy Spreadsheet"
                title="Yoybuy Spreadsheet заказ товаров"
                loading="lazy"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SEO Article 2 */}
      <section className="w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Neatly%20wrapped%20parcels%20and%20shipping%20boxes%20with%20tracking%20labels%20on%20warm%20cream%20surface%20soft%20natural%20lighting%20editorial%20product%20photography%20international%20delivery%20concept%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=450&seq=yoybuy-guide-v2-02&orientation=landscape"
                alt="Доставка из Китая через Yoybuy"
                title="Yoybuy Spreadsheet доставка"
                loading="lazy"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
            <div>
              <span className="text-[11px] tracking-[0.2em] uppercase text-primary-500 font-label font-medium">
                Статья 2
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-3 mb-4 leading-snug"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Доставка из Китая — все способы и сроки
              </h2>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-4">
                <strong>Yoybuy Spreadsheet</strong> поддерживает несколько способов доставки: авиапочта
                (7-14 дней), экспресс-доставка (3-7 дней), морская доставка (25-40 дней) и железнодорожный
                транспорт (15-25 дней). Выбор способа зависит от вашего бюджета и срочности заказа.
              </p>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-5">
                Система <strong>Yoybuy Sheet</strong> автоматически рассчитывает стоимость доставки
                на основе веса и габаритов товаров. Вы всегда видите точную сумму до подтверждения заказа,
                что исключает неприятные сюрпризы при получении.
              </p>
              <Link
                to="/article/yoybuy-spreadsheet-guide"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
              >
                Подробнее о доставке
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Article 3 */}
      <section className="w-full py-16 md:py-20 bg-white">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <span className="text-[11px] tracking-[0.2em] uppercase text-primary-500 font-label font-medium">
                Статья 3
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-3 mb-4 leading-snug"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Yoybuy Spreadsheet vs другие агенты
              </h2>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-4">
                На рынке представлены три основных агента с табличной системой заказа: Yoybuy Spreadsheet,
                Kakobuy Spreadsheet и Superbuy Spreadsheet. <strong>Yoybuy</strong> выделяется максимальной
                автоматизацией и простотой для новичков, в то время как конкуренты требуют более
                глубокого погружения в интерфейс и ручной работы.
              </p>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-5">
                Ключевые преимущества <strong>Yoybuy Sheet</strong>: полная автоматизация расчётов,
                прозрачная система комиссий, поддержка всех китайских маркетплейсов и интуитивно
                понятный табличный интерфейс, доступный даже начинающим пользователям.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white font-label text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  Попробовать Yoybuy
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </div>
                </a>
                <Link
                  to="/article/yoybuy-spreadsheet-guide"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
                >
                  Сравнение агентов
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Three%20minimalist%20cards%20arranged%20on%20warm%20cream%20surface%20representing%20comparison%20concept%20soft%20natural%20lighting%20editorial%20product%20photography%20clean%20composition%20warm%20beige%20tones%20no%20people&width=600&height=450&seq=yoybuy-guide-v2-03&orientation=landscape"
                alt="Yoybuy vs другие агенты сравнение"
                title="Yoybuy Spreadsheet сравнение агентов"
                loading="lazy"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SEO Article 4 */}
      <section className="w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20Taobao%20app%20interface%20beside%20tablet%20with%20spreadsheet%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20editorial%20product%20photography%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=450&seq=yoybuy-guide-v2-04&orientation=landscape"
                alt="Taobao через Yoybuy Sheet"
                title="Yoybuy Spreadsheet Taobao заказы"
                loading="lazy"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
            <div>
              <span className="text-[11px] tracking-[0.2em] uppercase text-primary-500 font-label font-medium">
                Статья 4
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-3 mb-4 leading-snug"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Как находить и выбирать товары на Taobao
              </h2>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-4">
                Taobao — крупнейший китайский маркетплейс с миллионами товаров. Через <strong>Yoybuy
                Spreadsheet</strong> вы можете заказывать с Taobao так же удобно, как в локальном
                интернет-магазине. Ключевые критерии выбора: рейтинг продавца, количество продаж,
                отзывы с фото и детальное описание товара.
              </p>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-5">
                Используйте встроенный поиск <strong>Yoybuy Sheet</strong> для быстрого сравнения
                цен у разных продавцов. Система автоматически подскажет оптимальный вариант
                с учётом рейтинга и стоимости доставки.
              </p>
              <Link
                to="/article/yoybuy-spreadsheet-guide"
                className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
              >
                Гид по Taobao
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Article 5 */}
      <section className="w-full py-16 md:py-20 bg-white">
        <div className="max-w-[860px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="order-2 md:order-1">
              <span className="text-[11px] tracking-[0.2em] uppercase text-primary-500 font-label font-medium">
                Статья 5
              </span>
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-3 mb-4 leading-snug"
                style={{ fontFamily: 'var(--font-heading)' }}>
                Как сэкономить до 40% на заказах через Yoybuy
              </h2>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-4">
                <strong>Yoybuy Spreadsheet</strong> помогает существенно экономить на закупках из Китая
                благодаря прозрачной системе комиссий и возможности сравнения цен. Объединяя несколько
                товаров в одну посылку, вы сокращаете стоимость доставки на каждого изделия.
              </p>
              <p className="text-sm md:text-[15px] text-foreground-600 font-light leading-relaxed mb-5">
                Дополнительные способы экономии с <strong>Yoybuy Sheet</strong>: отслеживание сезонных
                распродаж на китайских маркетплейсах, выбор оптимального способа доставки и накопление
                скидки для постоянных покупателей. В среднем пользователи экономят от 20 до 40%
                по сравнению с традиционными агентами.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-white font-label text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  Начать экономить
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </div>
                </a>
                <Link
                  to="/article/yoybuy-spreadsheet-guide"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-foreground-300 text-foreground-700 font-label text-sm hover:bg-foreground-100/50 transition-all duration-300 cursor-pointer"
                >
                  Все советы
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </div>
                </Link>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Savings%20concept%20with%20glass%20jar%20of%20coins%20beside%20calculator%20and%20shopping%20list%20on%20warm%20cream%20desk%20soft%20natural%20lighting%20editorial%20product%20photography%20warm%20beige%20tones%20clean%20composition%20no%20people&width=600&height=450&seq=yoybuy-guide-v2-05&orientation=landscape"
                alt="Экономия с Yoybuy Spreadsheet"
                title="Yoybuy Spreadsheet экономия"
                loading="lazy"
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="w-full py-16 md:py-20 bg-accent-900">
        <div className="max-w-[860px] mx-auto px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-4"
            style={{ fontFamily: 'var(--font-heading)' }}>
            Готовы попробовать Yoybuy Spreadsheet?
          </h2>
          <p className="text-white/60 font-light text-sm md:text-base mb-8 max-w-[500px] mx-auto">
            Присоединяйтесь к тысячам покупателей, которые уже используют Yoybuy Sheet для заказов из Китая.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-foreground-950 font-label text-sm font-medium hover:bg-white/90 transition-all duration-300 cursor-pointer"
            >
              Yoybuy Sheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <Link
              to="/"
              className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/30 text-white font-label text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer"
            >
              Вернуться на главную
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Гид по покупкам Yoybuy Sheet — руководства и статьи",
            "description": "Полное руководство по заказу товаров из Китая через Yoybuy Spreadsheet. Всё, что нужно знать о системе: от регистрации до получения посылки.",
            "url": "https://yoybuy.top/guide",
            "inLanguage": "ru",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Yoybuy.top",
              "url": "https://yoybuy.top"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Yoybuy Spreadsheet",
              "url": "https://yoybuy.top",
              "logo": {
                "@type": "ImageObject",
                "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fcef7be7473f7.jpeg"
              }
            },
            "about": {
              "@type": "Thing",
              "name": "Yoybuy Spreadsheet",
              "description": "Система заказа товаров из Китая через электронные таблицы"
            },
            "hasPart": [
              {
                "@type": "WebPage",
                "name": "Как заказать товары через Yoybuy Spreadsheet",
                "url": "https://yoybuy.top/article/yoybuy-spreadsheet-guide"
              }
            ]
          })
        }}
      />
    </main>
  );
}